export { preparePageContextForPublicUsageClient };
import { preparePageContextForPublicUsageClientShared } from '../shared/preparePageContextForPublicUsageClientShared.js';
function preparePageContextForPublicUsageClient(pageContext) {
    return preparePageContextForPublicUsageClientShared(pageContext);
}
